import { Models } from "@hex-insights/app-modules";
import { CalendarEvent } from "../../../Utilities";
import * as ModelFormat from "../_General";

// Note: the functions defined in this file can be passed to model field components for consistent formatting.

/**
 * Formats the name field of the CalendarEvent model.
 */
export function name(value: CalendarEvent["name"]): string {
	return Models.toString(value);
}

/**
 * Formats the description field of the CalendarEvent model.
 */
export function description(value: CalendarEvent["description"]): string {
	return Models.toString(value);
}

/**
 * Formats the location field of the CalendarEvent model.
 */
export function location(value: CalendarEvent["location"]): string {
	return Models.toString(value);
}

/**
 * Formats the imageURL field of the CalendarEvent model.
 */
export function imageURL(value: CalendarEvent["imageURL"]): string {
	return Models.toString(value);
}

/**
 * Formats the isAllDay field of the CalendarEvent model.
 */
export function isAllDay(value: CalendarEvent["isAllDay"]): string {
	return value ? "Yes" : "No";
}

/**
 * Formats the startTime field of the CalendarEvent model.
 */
export function startTime(value: CalendarEvent["startTime"] | null): string {
	if (value === null) {
		return "--";
	}
	return ModelFormat.time(value);
}

/**
 * Formats the endTime field of the CalendarEvent model.
 */
export function endTime(value: CalendarEvent["endTime"] | null): string {
	if (value === null) {
		return "--";
	}
	return ModelFormat.time(value);
}

/**
 * Formats the startDate field of the CalendarEvent model.
 */
export function startDate(value: CalendarEvent["startDate"] | null): string {
	if (value === null) {
		return "--";
	}
	return ModelFormat.date(value);
}

/**
 * Formats the isMultiDay field of the CalendarEvent model.
 */
export function isMultiDay(value: CalendarEvent["isMultiDay"]): string {
	return value ? "Yes" : "No";
}

/**
 * Formats the endDate field of the CalendarEvent model.
 */
export function endDate(value: CalendarEvent["endDate"] | null): string {
	if (value === null) {
		return "--";
	}
	return ModelFormat.date(value);
}

/**
 * Formats the allowsResponses field of the CalendarEvent model.
 */
export function allowsResponses(value: CalendarEvent["allowsResponses"]): string {
	return value ? "Yes" : "No";
}
